import { jsx as _jsx } from "react/jsx-runtime";
import { shallowEqual, useSelector } from 'react-redux';
import { AdditionalInfoView } from '../../../../redux/additionalInfo/typings';
import AdditionalInfoUploadReview from '../AdditionalInfoUploadReview';
import AdditionalInfoConfirmation from '../AdditionalInfoConfirmation';
import AdditionalInfoUpload from '../AdditionalInfoUpload';
import AdditionalInfoCancelConfirmation from '../AdditionalInfoCancelConfirmation';
import AdditionalInfoDeleteConfirmation from '../AdditionalInfoDeleteConfirmation';
import LoadingScreen from '../AdditionalInfoLoadingScreen';
var AdditionalInfoCurrentView = function () {
    var _a;
    var additionalInfoViews = (_a = {},
        _a[AdditionalInfoView.Upload] = _jsx(AdditionalInfoUpload, {}),
        _a[AdditionalInfoView.CancelConfirmation] = (_jsx(AdditionalInfoCancelConfirmation, {})),
        _a[AdditionalInfoView.Review] = _jsx(AdditionalInfoUploadReview, {}),
        _a[AdditionalInfoView.SubmitConfirmation] = _jsx(AdditionalInfoConfirmation, {}),
        _a[AdditionalInfoView.DeleteConfirmation] = (_jsx(AdditionalInfoDeleteConfirmation, {})),
        _a);
    var _b = useSelector(function (state) { return state; }, shallowEqual), isLoading = _b.ui.isLoading, currentView = _b.additionalInfo.currentView;
    if (isLoading) {
        return _jsx(LoadingScreen, {});
    }
    return additionalInfoViews[currentView];
};
export default AdditionalInfoCurrentView;
//# sourceMappingURL=index.js.map